import React from 'react';

import { CellTypeProps } from './interfaces';
import Types from './Types';

const Cell: React.FC<CellTypeProps> = (data) => {
  switch (data.type) {
    case 'color':
      return <Types.Color {...data} />;
    case 'badge':
      return <Types.Badge {...data} />;
    case 'arrow':
      return <Types.Arrow {...data} />;
    case 'heat':
      return <Types.Heat {...data} />;
    case 'progress':
      return <Types.Progress {...data} />;
    case 'status_visit':
      return <Types.StatusVisit {...data} />;
    case 'redirect':
      return <Types.Redirect {...data} />;
    case 'image':
      return <Types.Image {...data} />;
    case 'symbol':
      return <Types.Symbol {...data} />;
    default:
      return <Types.Default {...data} />;
  }
};

export default Cell;
